/** Criar ou trocar a senha da conta do portal (quem já está logado por link ou senha). */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { post } from '../lib/api';
import { erroDe, usePortalEu } from '../telas/portal/comum';

export const Route = createFileRoute('/portal/senha')({ component: Senha });

function Senha() {
  const eu = usePortalEu();
  const nav = useNavigate();
  const qc = useQueryClient();
  const [senha, setSenha] = useState('');
  const [confirma, setConfirma] = useState('');
  const salvar = useMutation({ mutationFn: () => post('/v1/portal/senha', { senha }), onSuccess: () => { void qc.invalidateQueries({ queryKey: ['portal', 'eu'] }); void nav({ to: '/portal' }); } });
  const ok = senha.length >= 8 && senha === confirma;
  return (
    <div className="pt-entrada" style={{ marginTop: 0 }}>
      <div><h1>{eu.data?.temSenha ? 'Trocar a senha' : 'Criar uma senha'}</h1><p style={{ color: 'var(--text-dim)', margin: '4px 0 0' }}>Com a senha você entra direto, sem depender do link por e-mail{eu.data && eu.data.empresas.length > 1 ? ' — e troca entre as suas empresas pelo topo da página' : ''}.</p></div>
      <form className="pt-card" style={{ display: 'flex', flexDirection: 'column', gap: 12 }} onSubmit={(ev) => { ev.preventDefault(); if (ok) salvar.mutate(); }}>
        <label className="field"><span className="rot">E-mail</span><input value={eu.data?.contato.email ?? ''} readOnly autoComplete="username" /></label>
        <label className="field"><span className="rot">Nova senha</span><input type="password" value={senha} onChange={(ev) => setSenha(ev.target.value)} autoComplete="new-password" autoFocus /><span className="ajuda">mínimo de 8 caracteres</span></label>
        <label className={`field${confirma && confirma !== senha ? ' erro' : ''}`}><span className="rot">Repita a senha</span><input type="password" value={confirma} onChange={(ev) => setConfirma(ev.target.value)} autoComplete="new-password" />{confirma && confirma !== senha && <span className="msg-erro">as senhas não conferem</span>}</label>
        {erroDe(salvar.error) && <div className="alerta erro">{erroDe(salvar.error)}</div>}
        <button className="btn primario" type="submit" disabled={!ok || salvar.isPending}>{salvar.isPending ? 'salvando…' : 'Salvar a senha'}</button>
        <button className="btn link" type="button" onClick={() => void nav({ to: '/portal' })}>Voltar ao início</button>
      </form>
    </div>
  );
}
